import React from "react";
import PolicyLayout from "./PolicyLayout";
import { SITE_CONFIG } from "../config/siteConfig";

function Accessibility() {
  return (
    <PolicyLayout
      title="Accessibility statement"
      intro={`${SITE_CONFIG.brand} works to keep product discovery, cart controls, policies and checkout understandable across keyboard, assistive-technology and small-screen use.`}
    >
      <section>
        <h2>Measures used in this storefront</h2>
        <ul>
          <li>Page landmarks, ordered headings, labelled navigation and descriptive link names.</li>
          <li>Keyboard-operable menus, product options, cart actions and checkout controls with visible focus treatment.</li>
          <li>Form labels, required-field messages and text descriptions of product material, size, colour, care and hazards.</li>
          <li>Responsive policy and commerce layouts that reflow for narrower screens and allow text enlargement.</li>
          <li>Payment-card entry on a hosted checkout instead of custom card controls inside this interface.</li>
        </ul>
      </section>

      <section>
        <h2>External steps</h2>
        <p>The hosted payment page and the visitor's selected email application have their own accessibility behaviour. If either external step blocks completion, report the starting page, intended task and the barrier so that the available shopping or support information can be provided in a practical alternative format.</p>
      </section>

      <section>
        <h2>Report a barrier</h2>
        <p>Include the page address, device, browser, assistive technology and action that did not work. Do not include card credentials. Accessibility help does not require a purchase, and a report will not reduce any consumer or privacy right.</p>
      </section>

      <section>
        <h2>Review after change</h2>
        <p>Navigation, form labels, keyboard behaviour, focus order and desktop/mobile reflow are rechecked when relevant site features or third-party steps change. Material updates to this statement appear under the revision date shown above.</p>
      </section>
    </PolicyLayout>
  );
}

export default Accessibility;
